import { promisify } from "util"
import { writeFile } from "fs"
import { fileMakeDirname } from "./fileMakeDirname.js"

const writeFilePromisified = promisify(writeFile)

export const fileWrite = async (file, content) => {
  await fileMakeDirname(file)
  return writeFilePromisified(file, content)
}
